import React, { useState, useEffect } from "react";

import { FONT_FAMILY, DEFAULT_FONT_FAMILY } from "@excalidraw/common";

import type { FontFamilyValues } from "@excalidraw/element/types";
import type { ExcalidrawImperativeAPI } from "@excalidraw/excalidraw/types";

// Map of font family values to their display names
const FONT_FAMILY_NAMES: Record<number, string> = {
  [FONT_FAMILY.Virgil]: "Virgil",
  [FONT_FAMILY.Helvetica]: "Helvetica",
  [FONT_FAMILY.Cascadia]: "Cascadia",
  [FONT_FAMILY.Excalifont]: "Excalifont",
  [FONT_FAMILY.Nunito]: "Nunito",
  [FONT_FAMILY["Lilita One"]]: "Lilita One",
  [FONT_FAMILY["Comic Shanns"]]: "Comic Shanns",
  [FONT_FAMILY["Liberation Sans"]]: "Liberation Sans",
  [FONT_FAMILY.Assistant]: "Assistant",
  [FONT_FAMILY.Inter]: "Inter",
  [FONT_FAMILY.Roboto]: "Roboto",
  [FONT_FAMILY["Open Sans"]]: "Open Sans",
  [FONT_FAMILY.Poppins]: "Poppins",
  [FONT_FAMILY.Lato]: "Lato",
  [FONT_FAMILY.Montserrat]: "Montserrat",
  [FONT_FAMILY["Source Sans Pro"]]: "Source Sans Pro",
  [FONT_FAMILY.Raleway]: "Raleway",
  [FONT_FAMILY.Ubuntu]: "Ubuntu",
  [FONT_FAMILY["Fira Sans"]]: "Fira Sans",
  [FONT_FAMILY.Merriweather]: "Merriweather",
  [FONT_FAMILY.Playfair]: "Playfair",
  [FONT_FAMILY["Times New Roman"]]: "Times New Roman",
  [FONT_FAMILY.Georgia]: "Georgia",
  [FONT_FAMILY["Courier New"]]: "Courier New",
};

export const FontFamilyList = ({
  style,
  excalidrawAPI,
}: {
  style?: React.CSSProperties;
  excalidrawAPI: ExcalidrawImperativeAPI | null;
}) => {
  const [selectedFont, setSelectedFont] =
    useState<FontFamilyValues>(DEFAULT_FONT_FAMILY);

  // Sync with Excalidraw's current font family
  useEffect(() => {
    if (excalidrawAPI) {
      const appState = excalidrawAPI.getAppState();
      if (appState.currentItemFontFamily) {
        setSelectedFont(appState.currentItemFontFamily);
      }
    }
  }, [excalidrawAPI]);

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const fontValue = parseInt(event.target.value, 10) as FontFamilyValues;
    setSelectedFont(fontValue);

    // Update Excalidraw's app state to change the default font family
    if (excalidrawAPI) {
      excalidrawAPI.updateScene({
        appState: {
          currentItemFontFamily: fontValue,
        },
      });
    }
  };

  return (
    <select
      className="dropdown-select dropdown-select__font-family"
      onChange={handleChange}
      value={selectedFont}
      aria-label="Select font family"
      style={style}
    >
      {Object.entries(FONT_FAMILY_NAMES).map(([value, name]) => (
        <option key={value} value={value}>
          {name}
        </option>
      ))}
    </select>
  );
};
